// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2Ymh8","content":"LayoutSettings_content__1NTDj"};